import Vue from "vue";
import Vuex from "vuex";
import createLoadingPlugin from "./plugins/vuex-loading";
const modules = require.context("./modules", false, /\.js$/);
const moduleConfig = {};
modules.keys().forEach((key) => {
  const matchRes = key.match(/[\\/](.*)\.js$/);
  if (!matchRes) return;
  const prop = matchRes[1];
  moduleConfig[prop] = modules(key).default;
});
Vue.use(Vuex);
const store = new Vuex.Store({
  state: {},
  getters: {},
  mutations: {},
  actions: {},
  modules: {
    ...moduleConfig,
  },
  plugins: [createLoadingPlugin({ namespace: "loading" })],
});
export default store;
